<template>
  <div id="boardViewPageContainer" class="background-container">
    <Header
      :isHeaderShow='true'
      :isHideOfficeButton='isHideOfficeButton'
      @toggle-side='isShowSideMenu = !isShowSideMenu'
    />
    <SideMenu
      :isShow='isShowSideMenu'
      @toggle-show='isShowSideMenu = !isShowSideMenu'
    />
    <div class="default-container">
      <div id="boardViewPage">
        <p class="category"><a :href='`/board/list/?category=${board.categories[0]}`'>{{ board.categoryCaption }}</a></p>
        <p class="title" v-html='board.title'></p>
        <div class="contents pc entry-content clear" ast-blocks-layout="true" v-html="board.contents"></div>
        <div class="contents mo entry-content clear" ast-blocks-layout="true" v-html="board.contents"></div>
      </div>
    </div>
    <div
      class="channel-talk que_btn"
      @click="handlerClickChannelTalkButton"
    ></div>
  </div>
</template>
<script>
import axios from 'axios'
import helpers from '@/assets/js/helpers';
import "@/assets/css/board/wordpress-theme/astra.min.css";
import "@/assets/css/board/wordpress-block-astra.css";
export default {
  name: 'BoardViewV2Page',
  components: {
    Header: () => import('@/components/common/CommonHeaderV2'),
    SideMenu: () => import('@/components/common/CommonHeaderV2SideMenu'),
  },
  data() {
    return {
      isAdmin: window.homefit.grade === 'admin',
      board: {},
      isShowSideMenu: false,
      isHideOfficeButton: true,
    }
  },
  created() {
    //call fetchBoard
  },
  mounted() {
    this.fetchBoard().then(() => {
      if (this.board.categories.includes(3) || this.board.categories.includes(11)) {
        setTimeout(() => {
          window.ChannelIO('boot', {
            pluginKey: '53a60258-6cf5-4846-9848-becfb024e3ba',
            memberId: window.homefit?.user?.encryptedId,
            customLauncherSelector: '.que_btn',
            hideChannelButtonOnBoot: false,
          })

          window.dispatchEvent(new Event('resize'))
        }, 300)
      }
    })
    axios.post('/api/associate/cookie/', { _method: 'post' })
    document.querySelector('.hf_layout_header_uikit_wrap').style.display =
      'none'
  },
  methods: {
    fetchBoard() {
      const id = helpers.getQueryParameter().id
      const uri = `/api/board/wordpress/post/`
      return axios
      .post(uri, {_method:'get', id})
      .then(response => {
        this.board = response.data.post
        if (!this.board.title) {
          location.replace('/')
        }
        this.isHideOfficeButton = this.board.isHideOfficeButton
      })
      .catch(() => {
        alert('잠시 후 다시 시도해주세요.')
      })
    },
    handlerClickBackButton() {
      if (!window.opener) {
        location.href = '/'
      } else {
        window.close()
      }
    },
    handlerClickHomeButton() {
      location.href = '/'
    },
    handlerClickChannelTalkButton() {
      setTimeout(() => {
        window.scrollTo({ top: 10 })
      }, 100)
    },
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/_index.scss';
@import '@/assets/scss/board/board.scss';
</style>
